import React from "react"
import Checkbox from "../Checkbox"
import styles from "./optionCards.module.css"

const OptionCards = ({ options = [], selected, onChange = () => { }, columns = 2 }) => (
    <div className={styles.options} style={{ "--option-columns": columns }}>
        {options.map(option => (
            <button key={option.id} type="button" className={`${styles.option} ${String(selected) === String(option.id) ? styles.active : ""}`} onClick={() => onChange(String(option.id))}>
                {option.icon && <span className={styles.icon}>{option.icon}</span>}
                <span className={styles.content}><strong>{option.value}</strong>{option.description && <small>{option.description}</small>}</span>
                <Checkbox checked={String(selected) === String(option.id)} />
            </button>
        ))}
    </div>
)

export default OptionCards
